import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class PricePlanStateSelectComponent implements IController {
  location: any;
  enableParentOption: boolean;
  showText: boolean;
  onChange: Function;

  $onInit() {
    if (_.isUndefined(this.enableParentOption)) {
      this.enableParentOption = true;
    }
  }


  changeStateTo(state) {
    _.isUndefined(state) ? _.unset(this.location, 'available') : _.set(this.location, 'available', state);
    this.onChange({location: this.location});
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programLocationStateSelect', {
    bindings: {
      location: '<',
      enableParentOption: '<?',
      showText: '<?',
      onChange: '&'
    },
    template: require('./program-location-state-select.html').default,
    controller: PricePlanStateSelectComponent
  });
